import React from 'react';
import './Question.css'

const AnswerYes = () => {
    return <div>
        <p>
            Yes, correct, in theory the result of running a purely 
            functional program can be proven mathematically.
        </p> 
    </div>
}

const AnswerNo = () => {
    return <div>
        <p>
            Mathematical proofs can indeed theoretically model exactly how a 
            purely functional program will behave for given inputs.
        </p>
    </div>
}

const Answer = (props) => {
    if (props.answer === 'answerYes') {
        return <AnswerYes />
    } else if (props.answer === 'answerNo') {
        return <AnswerNo />
    } else {
        return <p>Please click an answer button above.</p>
    }
}

class QProof extends React.Component {
    constructor(props) {
        super(props);
        this.state = {question: 'unanswered'};
    }
    render() {
        return <div className="Question">
            <p>
            Can mathematics accurately predict the behaviour of functional programming?
            </p>
            <br/>
            <div>
                <span className="Button Affirmative" 
                onClick={()=> this.setState({question: 'answerYes'})}
                > Yes </span>
                <span className="Button Negative"
                onClick={()=> this.setState({question: 'answerNo'})}                
                >No</span>
            </div>
            <br/>
            <Answer answer={this.state.question} />
        </div>
    }
}

export default QProof;


// WEBPACK FOOTER //
// ./src/components/q_proof.js